import { useRef, useState } from "react"
import {
  Box,
  IconButton,
  Popover,
  Tooltip,
  Typography,
  makeStyles,
} from "@material-ui/core"
import Badge from "@material-ui/core/Badge"
import PerfectScrollbar from "react-perfect-scrollbar"
import PropTypes from "prop-types"
import { Bell as BellIcon } from "react-feather"

const useStyles = makeStyles(() => ({
  popover: {
    width: 320,
  },
}))

const NotificationsBell = ({ title, total, children }) => {
  const classes = useStyles()
  const ref = useRef(null)
  const [isOpen, setOpen] = useState(false)

  return (
    <>
      <Tooltip title="Notificaciones">
        <IconButton ref={ref} onClick={() => setOpen(true)}>
          <Badge badgeContent={total} color="primary" overlap="rectangular">
            <BellIcon style={{ color: "initial" }} />
          </Badge>
        </IconButton>
      </Tooltip>
      <Popover
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        classes={{ paper: classes.popover }}
        getContentAnchorEl={null}
        anchorEl={ref.current}
        onClose={() => setOpen(false)}
        open={isOpen}
      >
        <Box p={2}>
          <Typography variant="h6" color="textPrimary">
            {title}
          </Typography>
        </Box>
        <PerfectScrollbar options={{ suppressScrollX: true }}>
          {children}
        </PerfectScrollbar>
      </Popover>
    </>
  )
}

NotificationsBell.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
  total: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
}

NotificationsBell.defaultProps = {
  children: null,
  title: "Notificaciones",
  total: 0,
}

export default NotificationsBell
